const calculatorContainerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
    width: "100%",
    maxWidth: 600,
    p: 4,
    gap: 1,
    boxSizing: "border-box",
  };

  export default calculatorContainerStyle